import { render, staticRenderFns } from "./SideworkRegistry.vue?vue&type=template&id=536a5a82&scoped=true&"
import script from "./SideworkRegistry.vue?vue&type=script&lang=js&"
export * from "./SideworkRegistry.vue?vue&type=script&lang=js&"
import style0 from "./SideworkRegistry.vue?vue&type=style&index=0&id=536a5a82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "536a5a82",
  null
  
)

export default component.exports